export const bindNumberInRange = (value, minimum, maximum) => {
  if (Number.isNaN(value)) {
    return minimum;
  }

  return Math.min(Math.max(minimum, value), maximum);
};